import { render } from "./Part.vue?vue&type=template&id=bc11a1a2"
import script from "./Part.vue?vue&type=script&lang=js"
export * from "./Part.vue?vue&type=script&lang=js"
script.render = render

export default script